import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import moment from 'moment'
import OrganizationUsers from './OrganizationUsers'

@withGraphQL(gql`
  query organization($organizationId: ID) {
    organization(organizationId: $organizationId) {
      _id
      name
      slug
      createdBy {
        emails {
          address
        }
      }
      createdAt
      members {
        _id
        userId
        email
        roles
      }
    }
  }
`)
export default class OrgInformation extends React.Component {
  static propTypes = {
    organization: PropTypes.object
  }

  renderInformation() {
    console.log(this.props.organization)
    return (
      <div className={styles.info}>
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            <b>Organization Id:</b>
          </div>
          <div className="col-xs-12 col-sm-9">{this.props.organization._id}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            <b>Slug:</b>
          </div>
          <div className="col-xs-12 col-sm-9">{this.props.organization.slug}</div>
        </div>
        <br />
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            <b>CreatedBy:</b>
          </div>
          <div className="col-xs-12 col-sm-9">
            {this.props.organization.createdBy.emails[0].address}
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-xs-12 col-sm-2">
            <b>CreatedAt:</b>
          </div>
          <div className="col-xs-12 col-sm-9">
            {moment(this.props.organization.createdAt).format('DD/MM/YYYY HH:mm')}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3>Organización: {this.props.organization.name}</h3>
          </div>
          <div className="content" style={{backgroundColor: 'white'}}>
            {this.renderInformation()}
          </div>
        </div>
        <OrganizationUsers organizationId={this.props.organization._id} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/OrgInformation/index.js